import { FC } from 'react';
import { TypesCount } from '../../models/SingleUnit';
import { Tooltip } from 'primereact/tooltip';

interface Props {
  value: TypesCount;
}

const SingleUnitCardData: FC<Props> = ({ value }) => {
  const className = value.targetSkillType.toLocaleLowerCase();
  // Bare .target/.support would match anything else on the page carrying those classes.
  const cardClassName = `nc_unit-card-${className}`;

  return (
    <>
      <Tooltip target={`.${cardClassName}`}>
        {className == 'target'
          ? 'These skills are the primary skills that contribute to the goal of the unit, arranged in order of difficulty.'
          : className == 'support'
          ? 'These are the essential and helpful predecessors for target skills. Completing these skills will increase student readiness to engage with the target skills.'
          : 'These skills are related to the target skills but are not included in the unit progress goal. They apply and reinforce understanding of the unit’s target skills.'}
      </Tooltip>
      <div className={`tw-flex lg:tw-flex-col tw-flex-row tw-gap-x-2 tw-items-center ${cardClassName}`}>
        <i className={`icon-sm lg:tw-pb-2 tw-text-stone-500 nc_icon-nc_${className}`} />
        <h3 className="tw-text-neutral-950 tw-font-atkinson tw-text-sm tw-font-bold">
          {value.count} {value.targetSkillType} Skills
        </h3>
      </div>
    </>
  );
};

export default SingleUnitCardData;
